import type {ReactElement} from 'react';
import type {Editor} from 'grapesjs';
import {EmailMakerPublishingOptionsPopup} from '@Components/email-maker-publishing-options-popup';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import type {EmailCampaign} from '@Components/email-marketing-campaigns/email-marketing-campaigns.types';
import {EditorViewport} from '@EmailMakerReact/email-maker-react.types';
import {resolveEmailCampaign} from '@EmailMakerReact/lib/email-maker-storage-library';
import type {PublishingOptionsMenuProps} from './publishing-options-menu.types';
import {ICON_MORE_HORIZONTAL, PUBLISHING_OPTIONS_DROPDOWN_ALIGNMENT} from './publishing-options-menu.types';
import {MobileMoreOptionsButton} from './components/mobile-more-options-button/mobile-more-options-button';

export function PublishingOptionsMenu({editorViewport, editor}: PublishingOptionsMenuProps): ReactElement | null {
  if (editor === null) {
    return null;
  }

  if (editorViewport === EditorViewport.MOBILE) {
    return <MobileMoreOptionsButton editor={editor} />;
  }

  return renderDesktopPopup(editor);
}

function renderDesktopPopup(editor: Editor): ReactElement {
  const selector = (
    <Icon icon={ICON_MORE_HORIZONTAL} shape={IconShape.SQUARE} type={IconType.SECONDARY} size={IconSize.SIZE_ICON_20} ariaLabel={window.i18next.t('pmwjs_publishing_options')} />
  );

  return (
    <EmailMakerPublishingOptionsPopup
      selector={selector}
      dropdownAlignment={PUBLISHING_OPTIONS_DROPDOWN_ALIGNMENT}
      getEmailCampaign={(): Promise<EmailCampaign | undefined> => resolveEmailCampaign(editor)}
    />
  );
}
